import { render, staticRenderFns } from "./CarePlansPage.vue?vue&type=template&id=0dc3b65a"
import script from "./CarePlansPage.vue?vue&type=script&lang=js"
export * from "./CarePlansPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports